<template>
  <div>
    <ProgressWaves :color="color"
                   :width="moneySpent"
                    class="mb-1"/>
    <MyBudgetsPreviewDays :color="color"
                          :show-days="showDays"
                          :days-passed="daysPassed"/>
  </div>
</template>

<script>
import MyBudgetsPreviewDays from "@/components/cabinet/Money/Dashboard/MyBudgets/MyBudgetsPreview/MyBudgetsPreviewDays";
import ProgressWaves from "@/components/common/ProgressWaves";

export default {
  name: "MyBudgetsPreview",
  props: {
    daysPassed: {
      type: Number,
      required: true
    },
    moneySpent: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true,
      validator: (val) => ['redBlinking', 'red', 'orange', 'yellow', 'lightGreen', 'green'].includes(val)
    },
    showDays: {
      type: Boolean,
      default: true
    }
  },
  components: {ProgressWaves, MyBudgetsPreviewDays}
}
</script>